import React from 'react'
import { useGlobalContext } from '../context';
import { Link } from 'react-router-dom'

function LatestProduct() {
    const { addToBag, products } = useGlobalContext()

    if (products.length > 0) {
        const { id, name, sizes, price, image, inStock } = products[6];
        return (
            <section className='latest_product'>
                <div className="container">
                    <h1 className='section-title'>Latest Product</h1>
                    <div className="product-image">
                        <img src={image[0]} alt="" />
                        <div className="product-price">{price} <span>LE</span></div>
                    </div>
                    <div className="product-info">
                        <Link to={`/product/${id}`} className="product-name">
                            {name}
                        </Link>
                        <p className="product-desc">Lorem ipsum dolor sit amet consectetur adipisicing elit.</p>
                        <ul className="feats">
                            <li className='feat'>Lorem, ipsum.</li>
                            <li className='feat'>Lorem, ipsum dolor.</li>
                            <li className='feat'>Lorem dolor sit.</li>
                        </ul>
                        <ul className="sizes">
                            Sizes:
                            {sizes.map((size, index) => {
                                return (
                                    <li className="size" key={index}>{size}</li>
                                )
                            })}
                        </ul>
                        <button className="add-to-bag" onClick={() => addToBag(id)}>add to bag</button>
                    </div>
                </div>
            </section>
        )
    } else {
        return ' '
    }


}

export default LatestProduct